<!-- 公告详情页 -->
<template> 
  <div class="home">
     <div class="contLeft">
       <div style="padding: 30px 20px;">
          <div class="noticeDetail">
            <h1>{{ noticeData.title }}</h1>
            <div class="noticeInfo">
                发布时间：{{ noticeData.push_date }}
            </div>
            <div class="noticeContent">
              <div v-html="noticeData.content" style="width: 90%;margin: 0 auto;"></div>
            </div>
          </div> 
        </div>
     </div>
     <div class="contRight">
      <div class="rightH4">
        <div class="rightH4Title">公告</div>
        <div class="rightH4Cont"> 
            <div 
              class="item"
              v-for="(item, index) in noticeList"
              :key="index"
              @click="noticeClick(item)"
            >
              <el-tag
                effect="plain" 
                style="margin-right: 10px;"
                >
                {{ item.type_name }}
              </el-tag>
              <span>{{ item.title }}</span>
            </div> 
        </div>
        <div class="rightH4Bottom" style="text-align: right;">
          <el-button type="text" @click="noticeMore(item)">更多...</el-button>
        </div>  
      </div>
     </div> 
  </div> 
</template>

<script>
import commonApi from "@/api/common"; 
import qee from "qf-export-excel";
import { clearObj, copyToClip } from "@/utils/index.js";
import { deepClone } from "@/utils"; 
import MyButton from "@/components/MyButton.vue";
export default {
  name: "noticeDetail", //公告详情页
  components: {
    MyButton,
  },
  data() {
    return {
      noticeData:{},
      noticeList:[],
      un_read_show: true
    };
  },
  computed: { 

  },
  watch: {
     
  },
  created() {  
      console.log("getNoticeDetail---id", this.$route.query.id)
      if (this.$route.query.id) {
        this.getNoticeDetail(this.$route.query.id)
      }
      this.getNoticeList(); 
  },
  methods: {
      noticeMore(){
        console.log("noticeMore")
        this.$router.push({
          path: "/noticeList", 
        });
      },
      noticeClick(e){
        console.log("noticeClick",e)
        this.getNoticeDetail(e.id)
        // this.$router.push({
        //   path: "/noticeDetail",
        //   query: {
        //     id: e.id,
        //   },
        // });
      },
      getNoticeList(){
        commonApi.getNoticeList({limit: 4, page: 1, total: 0,  }).then((res) => {
          console.log("getNoticeList", res.data);
          this.noticeList = res.data.list;
        });
      },
      async getNoticeDetail(e){
          const res = await commonApi.getTobNoticeInfo({id: e});
          if (res.code == 200) {
            this.noticeData = res.data.info
            if( res.data.un_read_total == 0){   
              localStorage.setItem("un_read_total", res.data.un_read_total)  
              console.log("un_read_show", localStorage.getItem("un_read_show"))
              if (localStorage.getItem("un_read_show") == 'false' || localStorage.getItem("un_read_show") == null) {
                console.log("111111", localStorage.getItem("un_read_show"))
                localStorage.setItem("un_read_show", true)  
                location.reload()
              }
            }
          } else {
              this.$message.error(res.message);
          }
      }
  },
};
</script>

<style lang="less" scoped>
.basicStyle { 
  padding: 16px;
  span {
    display: inline-block;
  }
  .querySearch {
    .searchItem {
      display: inline-block;
      padding: 5px 0;
      margin-right: 30px;
      span {
        margin-right: 10px;
        font-size: 14px;
      }
      /deep/ .el-input {
        width: 250px;
        padding: 5px 0;
      }
    }
    /deep/ .el-button--primary {
      // margin-left: 50px;
    }
  }
  .addInfo {
    margin: 10px 0 20px 0;
  }

  // 表格数据
  .table {
    min-height: calc(100vh - 330px);
  }
  // .operationItem {
  //   display: inline-block;
  //   margin: 0 5px;
  //   cursor: pointer;
  //   color: rgb(87, 87, 239);
  // }
  // .operationItem:hover {
  //   color: red;
  // }

  // 分页
  .pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 20px;
  }

  /deep/ .formDialog {
    .courseDetail {
      img {
        width: 200px;
      }
      .couseUl {
        text-decoration: none;
        height: 400px;
        overflow: auto;
        margin-top: 20px;
        li {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .sellPriceType {
          background-color: rgb(89, 89, 246);
          color: #fff;
          margin: 0 25px;
          width: 100px;
          text-align: center;
          border-radius: 10px;
        }
      }
    }
    .userInfoFormStyle {
      display: flex;
      line-height: 40px;
      margin-bottom: 15px;
      .t1 {
        padding: 0 12px 0 0;
        width: 100px;
        box-sizing: border-box;
        text-align: right;
      }
      .t2 {
      }
      .t3 {
      }
    }
    .userInfoFormStyle-price {
      display: flex;
      line-height: 40px;
      margin-bottom: 15px;
      justify-content: start;
      padding: 0 20px;
      .userInfoFormStyle-price-item {
        width: 50%;
      }
    }
    .el-select .el-input {
      width: 180px;
    }
    .el-input {
      width: 250px;
    }
    .dialog-footer {
      text-align: center;
    }
    .roleStyle {
      .el-form-item__content {
        display: flex;
        align-items: center;
        .el-form-item__content {
          margin-left: 0 !important;
        }
        img {
          width: 20px;
          height: 20px;
          margin-left: 10px;
          cursor: pointer;
        }
        .el-button {
          border: none;
          padding-left: 5px;
        }
        .el-button:focus,
        .el-button:hover {
          background-color: #fff;
        }
      }
    }
  }
}

.teach-extend-box {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .teach-extend-box-tc {
    color: #d9001b;
  }
}
/deep/ input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
/deep/ input[type="number"] {
  -moz-appearance: textfield !important;
}
/deep/ .el-input-group__append,
.el-input-group__prepend {
  background-color: #409eff;
  color: #fff;
  border: 1px solid #409eff;
}
/deep/.el-tree-node__content {
  display: flex;
  align-items: center;
  height: 40px;
  cursor: pointer;
  padding-right: 15px;
}
/deep/.noticeDetail{
  h1{
    text-align: center;
  }
  .noticeInfo{
      text-align: center;
      padding: 20px;
      font-size: 14px;
      color: #606266;
  }
  .noticeContent{ 
    font-size: 14px;
    color: #000000;
    margin: 0 auto;
    line-height: 140%;
    
    img{
      max-width: 100%;
    }
  }
}


.home {
width: 100%;
padding: 16px;
box-sizing: border-box;
// overflow: auto;
overflow-x: initial;
display: flex;
justify-content: space-between;
min-width: 1200px;
background: #f7f8fb;
.contLeft {
  width: 75%;
  min-width: 1020px;
  margin-right: 20px;
  background-color: #fff;

}
.contRight {
  width: 22%;
  min-width: 360px;
  display: block;
  background-color: #fff;
   
  
  .rightH4{
      background: #ffffff;
      border-radius: 8px;
      padding: 30px;
      margin-bottom: 20px;
      .rightH4Title{
        font-size: 18px;
        color: #191b27;
        padding-bottom: 20px;
        border-bottom: 1px solid #e7eaf0;
      }
      .rightH4Cont{
        padding-top: 20px; 
        .item{
          margin-bottom: 15px;
          display: flex;
          cursor: pointer;
          span{
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 200px;
            display: block;
            line-height: 30px;
            font-weight: 100;
            font-size: 13px;
          }
        }
      }

  }

}
}
</style>
